import { render, staticRenderFns } from "./MatchClassPage.vue?vue&type=template&id=3a60e960&scoped=true&"
import script from "./MatchClassPage.vue?vue&type=script&lang=ts&"
export * from "./MatchClassPage.vue?vue&type=script&lang=ts&"
import style0 from "./MatchClassPage.vue?vue&type=style&index=0&id=3a60e960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60e960",
  null
  
)

export default component.exports